import { formatDateX } from "framework/utils/date/formatDateX";

export const formatCreatedDate = (date: Date) => {
    const from = new Date(date);
    const to = new Date();
    const format = from.getFullYear() === to.getFullYear() && from.getFullYear() === new Date().getFullYear() ? 'dd/MM HH:mm' : 'dd/MM/yyyy HH:mm';
    return formatDateX(date, format);
}
